import { instance2 } from "App/constants";
import { defaultToastError, defaultToastSuccess } from "App/utils/helpers";
import { makeStyles } from "@material-ui/core/styles";
import { DEFAULT_BOX_SHADOW, PRIMARY_BACKGROUND } from "App/constants/theme";
import { LIST_URL_MASTER } from "utils/masters";

export const STYLE_JENIS_LAYANAN = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  paper: {
    backgroundColor: PRIMARY_BACKGROUND,
    boxShadow: DEFAULT_BOX_SHADOW,
    padding: "1rem 1.5rem",
  },
  table: {
    width: "97%",
    margin: "0 auto",
  },
}));

export const RESET_STATE_JENIS_LAYANAN = {
  id: "",
  name: "",
  harga: "0",
  harga2: "0",
  kode_bridge: "",
  typeofcare_code: "Layanan Rawat Jalan",
  remark: "-",
};

export const getAllJenisLayanan = async () => {
  try {
    const api = await instance2.get(LIST_URL_MASTER.jenis_layanan.list);
    const res = api.data;
    return res.body;
  } catch (error) {
    defaultToastError(error?.response?.data?.message);
    return false;
  }
};

export const deleteJenisLayananById = async (
  id,
  run,
  setShowModalDeleteConfirm,
  setFormData
) => {
  try {
    await instance2.post(
      LIST_URL_MASTER.jenis_layanan.delete,
      {},
      {
        headers: {
          idjenis_layanan: id,
        },
      }
    );
    run(!run);
    setShowModalDeleteConfirm(false);
    setFormData(RESET_STATE_JENIS_LAYANAN);
    return defaultToastSuccess("Data berhasil dihapus");
  } catch (error) {
    return defaultToastError(error?.response?.data?.message);
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "id",
    disablePadding: false,
    label: "ID",
    align: "left",
  },
  {
    id: "name",
    disablePadding: false,
    label: "INFO",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "kode_bridge",
    disablePadding: false,
    label: "KODE BRIDGE",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "harga",
    disablePadding: false,
    label: "HARGA",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "typeofcare_code",
    disablePadding: false,
    label: "JENIS RAWAT",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "remark",
    disablePadding: false,
    label: "REMARK",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "inserted_time",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "inserted_by",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updated_time",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updated_by",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];
